import { createSlice } from "@reduxjs/toolkit";
import { getBusinessReport } from "./BusinessReport.thunk";

const initialState = {
  entities: [],
  status: "idle",
  error: null,
  page: 1,
  pageSize: 10,
  totalRecords: 0,
};

export const businessReportSlice = createSlice({
  name: "businessReport",
  initialState,
  reducers: {
    setBusinessReportPage: (state, action) => {
      state.page = action.payload;
    },
    setBusinessReportPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },
    resetBusinessReport: (state) => {
      state.entities = [];
      state.status = "idle";
      state.error = null;
      state.page = 1;
      state.pageSize = 10;
      state.totalRecords = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getBusinessReport.fulfilled, (state, action) => {
        state.entities = action.payload.entities || [];
        state.page = action.payload.page || state.page;
        state.pageSize = action.payload.pageSize || state.pageSize;
        state.totalRecords = action.payload.totalRecords || 0;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getBusinessReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error cargando Business Report";
      });
  },
});

export const {
  setBusinessReportPage,
  setBusinessReportPageSize,
  resetBusinessReport,
} = businessReportSlice.actions;

export default businessReportSlice.reducer;
